import React, { useState } from 'react';
import { useAuth } from '../lib/AuthContext';
import { Button } from './ui/Button';
import { Card, CardHeader, CardTitle, CardContent } from './ui/Card';
import { createOrUpdateUserDocument, checkForCompletedQuestionnaires, getAllCompletedQuestionnaires } from '../lib/firebase';

const FirebaseDebug: React.FC = () => {
  const { currentUser } = useAuth();
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState<any>(null);
  const [error, setError] = useState<string | null>(null);

  const handleCreateUserDocument = async () => {
    if (!currentUser) {
      setError('No user is logged in');
      return;
    }

    setLoading(true);
    setError(null);
    try {
      await createOrUpdateUserDocument(currentUser);
      setResult({
        success: true,
        message: `User document created/updated for ${currentUser.email}`
      });
    } catch (err) {
      console.error('Error creating user document:', err);
      setError(`Error: ${err instanceof Error ? err.message : 'Unknown error'}`);
    } finally {
      setLoading(false);
    }
  };

  const handleCheckQuestionnaires = async () => {
    setLoading(true);
    setError(null);
    try {
      const dbCheck = await checkForCompletedQuestionnaires();
      const questionnaires = await getAllCompletedQuestionnaires();
      
      setResult({
        dbCheck,
        questionnaires
      });
    } catch (err) {
      console.error('Error checking questionnaires:', err);
      setError(`Error: ${err instanceof Error ? err.message : 'Unknown error'}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card className="mb-6">
      <CardHeader>
        <CardTitle>Firebase Debug Tools</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <div>
            <p className="mb-2">Current User: {currentUser ? currentUser.email : 'None'}</p>
            <div className="flex gap-4">
              <Button 
                onClick={handleCreateUserDocument} 
                disabled={loading || !currentUser}
              >
                Create/Update User Document
              </Button>
              <Button 
                onClick={handleCheckQuestionnaires} 
                disabled={loading}
              >
                Check All Questionnaires
              </Button>
            </div>
          </div>

          {error && (
            <div className="p-4 bg-red-50 text-red-800 rounded-md">
              {error}
            </div>
          )}

          {result && (
            <div className="p-4 bg-gray-50 rounded-md">
              <h3 className="font-medium mb-2">Result:</h3>
              <pre className="whitespace-pre-wrap text-sm">
                {JSON.stringify(result, null, 2)}
              </pre>
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
};

export default FirebaseDebug; 